import IApiResponse from "../../interfaces/IApiResponse";
import DexieDB from '../../data/DexieDB'
import SuccessApiResponse from "../../data/SuccessApiResponse";
import IReadingPlanRecord from "../../interfaces/IReadingPlanRecord";
import { IReadingPlanRecordService } from "../ReadingPlanRecordService";

const ReadingPlanRecordServiceWeb: IReadingPlanRecordService = {
    
    createReadingPlanRecord: (readingPlanRecord) => {
        const newRecord: any = {...readingPlanRecord};
        delete newRecord.id;
        newRecord.modifiedDate = new Date(Date.now());
        const dbResponse: Promise<IApiResponse<IReadingPlanRecord>> = DexieDB.transaction('rw', DexieDB.readingPlanRecords, async()  => {
            
            return DexieDB.readingPlanRecords.add(newRecord).then((recordId)=>{
                newRecord.id = recordId;
                const response = {...SuccessApiResponse, Data: newRecord};
                response.Message.UserMessage = 'SUCCESS: SAVED PLAN.';
                return response;
            });
        }).catch((error)=>{
            const response = {
                Data: newRecord,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IReadingPlanRecord>;
        });

        return dbResponse;
    },
    getReadingPlanRecord: (activeReadingPlanId: number) =>  {
        const dbResponse: Promise<IApiResponse<IReadingPlanRecord>> = DexieDB.transaction('r', DexieDB.readingPlanRecords, async()  => {
            return DexieDB.readingPlanRecords.toArray().then((records)=>{
                if(records && records.length) {
                    const activeRecord = records.find((record) => record.id === activeReadingPlanId);
                    const result = activeRecord ? activeRecord : records[0];
                    return  {...SuccessApiResponse, Data: result};
                } else {
                    return {
                        Data: undefined,
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND READING PLAN RECORD', ServerMessage: 'FAILED TO GET' }
                    }
                }
            });
        }).catch((error)=>{
            const response = {
                Data: undefined,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IReadingPlanRecord>;
        });

        return dbResponse;
    },
    getReadingPlanRecords: () =>  {
        const dbResponse: Promise<IApiResponse<IReadingPlanRecord[]>> = DexieDB.transaction('r', DexieDB.readingPlanRecords, async()  => {
            return DexieDB.readingPlanRecords.toArray()
            .then((result)=>{
                if(result && result.length) {                  
                    return  {...SuccessApiResponse, Data: result};
                } else {
                    return {
                        Data: [],
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND READING PLAN RECORDS', ServerMessage: 'FAILED TO GET' }
                    }
                }
            });
        }).catch((error)=>{
            const response = {
                Data: [],
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IReadingPlanRecord[]>;
        });

        return dbResponse;
    },
    updateReadingPlanRecord: (readingPlanRecord, isSyncUpdate?) => {
        // If this an update from a cloud sync don't modify the date
        const updateRecord = isSyncUpdate ? {...readingPlanRecord} : {...readingPlanRecord, modifiedDate: new Date(Date.now())};
        const dbResponse: Promise<IApiResponse<IReadingPlanRecord>> = DexieDB.transaction('rw', DexieDB.readingPlanRecords, async()  => {
            return DexieDB.readingPlanRecords.put(updateRecord).then((result)=>{
                const response = {...SuccessApiResponse, Data: updateRecord};
                response.Message.UserMessage = 'SUCCESS: UPDATED PLAN';
                return response;
            });
        }).catch((error)=>{
            const response = {
                Data: updateRecord,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IReadingPlanRecord>;
        });

        return dbResponse;
    },

    deleteReadingPlanRecord: (recordId) => {
        const dbResponse: Promise<IApiResponse<boolean>> = DexieDB.transaction('rw', DexieDB.readingPlanRecords, async()  => {
            return DexieDB.readingPlanRecords.delete(recordId).then((result)=>{
                return {...SuccessApiResponse, Data: true};
            });
        }).catch((error)=>{
            const response = {
                Data: false,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<boolean>;
        });

        return dbResponse;
    },
}

export default ReadingPlanRecordServiceWeb;